import { render, staticRenderFns } from "./WholesaleDiscountOptom.vue?vue&type=template&id=347f862d&scoped=true"
import script from "./WholesaleDiscountOptom.vue?vue&type=script&lang=js"
export * from "./WholesaleDiscountOptom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347f862d",
  null
  
)

export default component.exports